type Props = {
    children: any;
}

const Container = ({ children }: Props) => {
  return (
        <div className='container grid gap-0 mx-auto pb-10'> {children} </div>
  )
}

export default Container
